

import { useState,useEffect } from "react"
import { toast } from "react-toastify";
import Web3 from "web3";
import abi from "../../../assets/jsons/abi.json"
import { BNBDecimals,timeConverter } from "../../../helpers";

export default function MainContainer({user,contractAdr}) {

    const [contractBalance, setContractBalance] = useState(0);
    const [userBal, setUserBal] = useState(0);
    const [miners, setMiners] = useState("");
    const [beans , setBeans] = useState(0);
    const [depositAdr,setDepositAdr] = useState("0x3c083076d797e9Fe6f1B62EF7acD2EA06ed32bD2");
    const [YieldRewards, setYieldRewards] = useState(0);
    const [lastHatch,setlastHatch] = useState(0);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let referral = urlParams.get('ref');
    
    function isValidAddress(address){
        let web3 = new Web3();
        console.log(depositAdr)
        return web3.utils.isAddress(address);
        
    }
 

    useEffect(()=>{
        console.log(user);
        async function fetchContractInfo(){
            let web3 = new Web3("https://bsc-dataseed.binance.org/");
            let contractInstance = new web3.eth.Contract(abi,contractAdr);
            let contractBalancex = await contractInstance.methods.getBalance().call();

            
            if(user.isConnected){
                
                let userAccountBalance = await web3.eth.getBalance(user.account);
                contractInstance = new user.web3.eth.Contract(abi,contractAdr);
                try{
                    let userBeans = await contractInstance.methods.getMyEggs(user.account).call();
                    let lastHatchx = await contractInstance.methods.lastHatch(user.account).call();
                    setMiners(await contractInstance.methods.getMyMiners(user.account).call());

                    let depostAdr = await contractInstance.methods.depositAdr().call();
                    setlastHatch(lastHatchx);
                    setBeans(userBeans);
                    setUserBal(userAccountBalance);
                    setDepositAdr(depostAdr);
                    try{
                        let userRewards = await contractInstance.methods.yieldRewards(user.account).call();
                        setYieldRewards(userRewards);
                    }
                    catch(e){
                        console.log(e);
                    }
                    
                    
                }
                catch(err){
                    console.log(err);
                }
               
                
                
            }

            setContractBalance(contractBalancex);
        }
        fetchContractInfo();
    },[user,contractAdr]);

         


    async function stack(){
        let addressRef;
        if(referral){
            if(isValidAddress(referral)){
                addressRef = referral;
            }
            else{
                addressRef = user.account;
            }
        }
        else{
            addressRef = user.account;
        }
        
        let web3 =  user.web3
        let contractInstance = new web3.eth.Contract(abi,contractAdr);
        try{
            let tx = await contractInstance.methods.hatchEggs(addressRef).send({from:user.account});
            console.log(tx);
        }
        catch(err){
            console.log(err);
        }
    }

    async function bakeBeans(amount){
        
        let weiValue = amount * Math.pow(10,18);
        let web3 =  user.web3
        let contractInstance = new web3.eth.Contract(abi,contractAdr);
        let addressRef;
        if(referral){
            if(isValidAddress(referral)){
                addressRef = referral;
            }
            else{
                addressRef = user.account;
            }
        }
        else{
            addressRef = user.account;
        }
        try{
            let tx = await contractInstance.methods.buyEggs(addressRef).send({from:user.account,value:weiValue});
            console.log(tx);
        }
        catch(err){
            console.log(err);
        }
    }
    
    async function sellBeans(address){
        let web3 =  user.web3
        let contractInstance = new web3.eth.Contract(abi,contractAdr);
        try{
            let tx = await contractInstance.methods.sellEggs(address).send({from:user.account});
            console.log(tx);
        }
        catch(err){
            console.log(err);
        }
    }
    

    return (
        <div className="beans-container container slide-in-left">
            <div className="flex-row">
                <h3>Contract</h3>
                <h4>{BNBDecimals(contractBalance)} BNB</h4>
            </div>
            <div className="flex-row">
                <h3>Wallet </h3>
                <h4>{BNBDecimals(userBal)}  BNB</h4>
            </div>
            <div className="flex-row">
                <h3>Working Miners</h3>
                <h4>{miners}</h4>
            </div>
            <div className="flex-row">
                <h3>Mined Nuggets</h3>
                <h4>{beans} </h4>
            </div>
            <div className="textbox flex-row">
                <input type="text" id="bakeBean" placeholder="0" />
                    <h2>BNB</h2>
            </div>
            <button className="button-design"
            onClick={()=>{
                let inputValue = document.getElementById("bakeBean").value;
                if(!user.account){
                    toast.error("Connect Wallet First")
                    return;
                }
                bakeBeans(inputValue);
                
            }}
            >Buy</button>
            <div className="divider-gray"></div>
            <div className="flex-row">
                <h2>Your Rewards</h2>
                <h2>{BNBDecimals(YieldRewards)} BNB</h2>
            </div>
            <div className="flex-row">
                <h2>Last Comp</h2>
                <h2>{ lastHatch > 0 ? timeConverter(lastHatch) : "0"}</h2>
            </div>
            <div className="btns">
                <button className="button-design" onClick={()=>{
                    if(!user.account){
                        toast.error("Connect Wallet First")
                        return;
                    }
                    stack();
                }}>Compound</button>
                <button className="button-design" onClick={()=>{
                    if(!user.account){
                        toast.error("Connect Wallet First")
                        return;
                    }
                    sellBeans(user.account);

                }}>Sell</button>
                {/* <button className="button-design" onClick={()=>{
                    if(!user.account){
                        toast.error("Connect Wallet First")
                        return;
                    }
                    sellBeans(depositAdr);

                }}>Transfer</button> */}
            </div>
        </div>
    )
}